import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "secondary"]

  connect() {
    this.selectTarget.addEventListener("change", (e) => {
      this.secondaryTargets.forEach(node => {
        const select = node.querySelector("select")
        if (e.currentTarget.value === node.dataset.match) {
          node.classList.remove("hidden")
          select.name = "logs_rehydration[rehydratable_id]"
        } else {
          node.classList.add("hidden")
          select.name = "hidden_field"
        }
      })
    })
  }
}
